export default function initToggles() {
  const isPresent = document.querySelector("[data-toggle-element]");
  if (!isPresent) {
    return;
  }

  // Initialize a variable to track the last interaction type (mouse or keyboard)
  // Global flag to track keyboard navigation
  let isKeyboardNavigation = false;

  // Detect keyboard navigation (Tab or Shift+Tab)
  document.addEventListener("keydown", function (event) {
    if (event.key === "Tab") {
      isKeyboardNavigation = true;
    }
  });

  // Reset keyboard navigation flag on mouse interaction
  document.addEventListener("mousedown", function () {
    isKeyboardNavigation = false;
  });

  const toggles = document.querySelectorAll("[data-toggle-element]");
  const targets = document.querySelectorAll("[data-toggle-target]");

  function clearActives() {
    toggles.forEach((toggle) => {
      toggle.classList.remove("active");
    });
  }

  function clearWindows() {
    targets.forEach((target) => {
      target.classList.remove("is-visible");
    });
  }

  // Function to handle toggling of menu
  function toggleMenu() {
    const isActive = this.classList.contains("active");
    clearActives();
    clearWindows();

    if (!isActive) {
      this.classList.add("active");
      const targetId = this.getAttribute("data-toggle-element");
      const target = document.querySelector(
        `[data-toggle-target="${targetId}"]`
      );
      if (target) {
        target.classList.add("is-visible");
      }
    }
  }

  // Apply event listeners to toggle elements
  toggles.forEach((toggle) => {
    toggle.addEventListener("click", function (event) {
      // Prevents the menu from immediately closing due to subsequent focus event
      event.preventDefault();
      toggleMenu.call(this);
    });

    toggle.addEventListener("focus", function () {
      // Open the menu on focus if using keyboard navigation
      if (isKeyboardNavigation) {
        toggleMenu.call(this);
      }
    });
  });

  // Close menus with the Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      clearActives();
      clearWindows();
    }
  });

  // Function to close menus when clicking outside
  function documentClick(event) {
    if (
      !event.target.closest("[data-toggle-element]") &&
      !event.target.closest("[data-toggle-target]")
    ) {
      clearActives();
      clearWindows();
    }
  }

  // Apply click event listener to the document
  document.addEventListener("click", documentClick);
}
